export default __webpack_public_path__ + "static/media/ST3-F_450_I.ddb3afef.png";